import { render, staticRenderFns } from "./ScreenTranslucenciaNucal.vue?vue&type=template&id=433a747e&scoped=true&"
import script from "./ScreenTranslucenciaNucal.vue?vue&type=script&lang=js&"
export * from "./ScreenTranslucenciaNucal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTranslucenciaNucal.vue?vue&type=style&index=0&id=433a747e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a747e",
  null
  
)

export default component.exports